export default __webpack_public_path__ + "static/media/tick-active.fd5a8b8d.svg";